import { Link } from "react-router";
import defaultMastheadImage from "@assets/logo-masthead.svg";
import { RouteFactory } from "@src/app/routePaths";
import { cn } from "@util/helpers";

export type LogoMastheadProps = {
  rootClassName?: string;
  src?: string;
  link?: string;
  title?: string;
  imgWidth?: number;
  imgHeight?: number;
  isDisplayH1?: boolean;
};

export default function LogoMasthead({
  rootClassName = "",
  src = defaultMastheadImage,
  link = RouteFactory.home,
  title = "The Business Times",
  imgWidth = 475,
  imgHeight = 48,
  isDisplayH1 = false,
}: LogoMastheadProps): React.ReactElement {
  const LinkElement = () => (
    <Link to={`${link}?ref=logo`} title={title} reloadDocument>
      <img src={src} alt={title} width={imgWidth} height={imgHeight} />
    </Link>
  );

  if (isDisplayH1) {
    return (
      <div className={cn(rootClassName, "py-4 lg:py-0")}>
        <h1>
          <LinkElement />
        </h1>
      </div>
    );
  }

  return (
    <div className={cn(rootClassName, "py-4 lg:py-0")}>
      <LinkElement />
    </div>
  );
}
